/* Bloque 158: "COMPRAR AHORA" y "Más opciones de pago" en la ficha de producto.
   Añade al carrito la variante y la cantidad elegidas en el formulario del producto y lleva al checkout.
   - Usa FormData del propio formulario del producto (id de variante y cantidad actuales, también con variantes).
   - Protección contra doble clic SOLO mientras se procesa; si falla se rehabilita y se muestra el error.
   - No pasa por product-form.js (los botones son type="button"), así que no abre el carrito ni lo modifica más
     que añadiendo ese artículo. */
(function () {
  if (window.ZTKBuyNow) return;
  window.ZTKBuyNow = true;

  var busy = false;

  function setBusy(root, on) {
    busy = on;
    var main = root.querySelector('.ztk-buy-now');
    var more = root.querySelector('.ztk-more-payment');
    if (main) {
      main.classList.toggle('loading', on);
      main.setAttribute('aria-disabled', on ? 'true' : 'false');
      if (!on) main.removeAttribute('aria-disabled');
      var spinner = main.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !on);
    }
    if (more) {
      if (on) more.setAttribute('aria-disabled', 'true');
      else more.removeAttribute('aria-disabled');
    }
  }

  function showError(root, message) {
    var wrapper = root.querySelector('.product-form__error-message-wrapper');
    var text = root.querySelector('.product-form__error-message');
    if (!wrapper || !text) return;
    text.textContent = message || '';
    wrapper.toggleAttribute('hidden', !message);
  }

  function buyNow(root) {
    var form = root.querySelector('form');
    if (!form || busy) return;
    var idInput = form.querySelector('[name=id]');
    if (!idInput || idInput.disabled || !idInput.value) return;

    setBusy(root, true);
    showError(root, '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok || result.json.status) {
          showError(root, result.json.description || result.json.message || '');
          setBusy(root, false);
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        showError(root, 'No se ha podido procesar la compra. Inténtalo de nuevo.');
        setBusy(root, false);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-ztk-buy-now]') : null;
    if (!button) return;
    event.preventDefault();
    var root = button.closest('product-form');
    if (root) buyNow(root);
  });

  // Si el navegador restaura la página al volver atrás desde el checkout, el botón vuelve a estar disponible.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var root = document.querySelector('product-form');
    if (root) setBusy(root, false);
  });
})();
